import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { getMyZonesQuery, getZonesQuery } from '../../queries/queries';
import { LoadingTable, EditButton, sortList, TableSection, TableHeader, Values } from '../../common/index';
import Form from './ZonesForm';

function ZonesTable({ superAdmin, zoneIds }) {
  const [editing, setEditing] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState(1);
  const sort = { sortBy, sortOrder, setSortBy, setSortOrder };

  const { data: zonesQuery, loading, error } = useQuery(superAdmin ? getZonesQuery : getMyZonesQuery, {
    variables: {
      ...(!superAdmin && { zoneIds: zoneIds })
    }
  });

  const toRender = zonesQuery;

  return (
    <TableSection>
      <div className="table-header">
        <h2>Zoner</h2>
        {superAdmin &&
          <EditButton size="sm add" setEditing={() => setEditing('new')} >Lägg till</EditButton>
        }
      </div>
      <table className="zone-table">
        <TableHeader
          columns={[
            { label: 'Zon', sortField: 'name' },
            { label: 'Administratörer' },
            { label: '' },
          ]}
          sort={sort}
        />
        <tbody>

          {editing === 'new'
            && <Form key="new" onComplete={() => setEditing('')} />}

          {!toRender?.zones ? <LoadingTable loading={loading} error={error} /> : (
            sortList(toRender?.zones, sort).map((obj) => (
              editing === obj._id
                ? <Form key={obj._id} content={obj} onComplete={() => setEditing('')} />
                : (
                  <tr key={obj._id}>
                    <td>{obj.name}</td>
                    <td>
                      {obj.adminEmails &&
                        <Values values={obj.adminEmails} />
                      }
                    </td>
                    <td>
                      <EditButton size="xs" setEditing={() => setEditing(obj._id)}>Redigera</EditButton>
                      <Link className="button secondary xs arrow" to={`/cities/${obj._id}/companies`}>Företag</Link>
                      <Link className="button secondary xs arrow" to={`/cities/${obj._id}/associations`}>Föreningar</Link>
                      <Link className="button secondary xs arrow" to={`/cities/${obj._id}/booklets`}>Häften</Link>
                    </td>
                  </tr>
                )
            ))
          )}

        </tbody>
      </table>
    </TableSection>
  );
}

export default ZonesTable;


